import { isDocumentDefined } from "../element/isDocumentDefined";

/**
 * Options for deleting a cookie
 */
export type DeleteCookieOptions = {
  /**
   * The domain the cookie was set on.
   * Must match the domain used when setting the cookie.
   */
  domain?: string;
  /**
   * The path the cookie was set on.
   * Must match the path used when setting the cookie.
   */
  path?: string;
};

/**
 * Deletes a cookie by setting its expiration to the past.
 * @param name - The name of the cookie to delete
 * @param options - Cookie options (domain, path) - must match how the cookie was set
 */
export function deleteCookie(
  name: string,
  options: DeleteCookieOptions = {},
): void {
  if (!isDocumentDefined()) {
    return;
  }

  const { domain, path = "/" } = options;

  let cookieString = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 GMT`;

  if (domain) {
    cookieString += `; domain=${domain}`;
  }

  cookieString += `; path=${path}`;

  // biome-ignore lint/suspicious/noDocumentCookie: cookie utility function
  document.cookie = cookieString;
}
